<script lang="ts">
	import MobileHeader from '$lib/MobileHeader.svelte';
	import { ConfirmDialog, loadCleintsStore, LoadingAnimation, login, Notificationholder, selectedClientStore } from '@enzianweb/shared';
	import '@enzianweb/shared/extensions';
	import '@enzianweb/shared/styles.css';
	import * as Sentry from '@sentry/svelte';
	import Big from 'big.js';
	
	interface Props {
		children?: import('svelte').Snippet;
	}

	let { children }: Props = $props();

	// DON'T REMOVE, this sets the amount of decimal points for big.js for the whole app
	Big.DP = 6;

	if (import.meta.env.MODE == 'production' || import.meta.env.MODE === 'demo') {
		Sentry.init({
			dsn: 'https://44837a9fa9cc4dddbd3e6c4bea8d6886@o4505520938024960.ingest.sentry.io/4505520968499200',
			environment: import.meta.env.MODE
		});
	}

	$effect(() => {
		if ($login != null && $selectedClientStore == null) {
			loadCleintsStore();
		}
	});
</script>

<div class="h-full flex flex-col">
	<MobileHeader />

	<div class="grow overflow-y-auto">
		{@render children?.()}
	</div>

	<ConfirmDialog />

	<Notificationholder />

	<LoadingAnimation />
</div>
